function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.7667 4.17504C15.6 3.68337 15.1333 3.33337 14.5833 3.33337H5.41667C4.86667 3.33337 4.40833 3.68337 4.23333 4.17504L2.5 9.16671V15.8334C2.5 16.2917 2.875 16.6667 3.33333 16.6667H4.16667C4.625 16.6667 5 16.2917 5 15.8334V15H15V15.8334C15 16.2917 15.375 16.6667 15.8333 16.6667H16.6667C17.125 16.6667 17.5 16.2917 17.5 15.8334V9.16671L15.7667 4.17504ZM5.41667 12.5C4.725 12.5 4.16667 11.9417 4.16667 11.25C4.16667 10.5584 4.725 10 5.41667 10C6.10833 10 6.66667 10.5584 6.66667 11.25C6.66667 11.9417 6.10833 12.5 5.41667 12.5ZM14.5833 12.5C13.8917 12.5 13.3333 11.9417 13.3333 11.25C13.3333 10.5584 13.8917 10 14.5833 10C15.275 10 15.8333 10.5584 15.8333 11.25C15.8333 11.9417 15.275 12.5 14.5833 12.5ZM4.16667 8.33337L5.41667 4.58337H14.5833L15.8333 8.33337H4.16667Z",
  fill: "#B458E4"
});

var SvgCar = function SvgCar(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/car.5c57823b.svg";
export { ForwardRef as ReactComponent };